import { Routes, RouterModule } from '@angular/router';
import { NotesComponent } from './notes.component';
import { ListNotesComponent } from './list-notes/list-notes.component';
import { EditNoteComponent } from './edit-note/edit-note.component';
import { AuthguardService } from '../authguard.service';
import { ModuleWithProviders } from '@angular/core';
import {ViewNoteComponent} from './view-note/view-note.component';

export const notesRoutes: Routes = [
    {
        path: 'notes',
        component: NotesComponent,
        canActivate: [AuthguardService], // comment out for testing during development
        children: [
            {path: '',
                redirectTo: 'list',
                pathMatch: 'full'},
            {path: 'new',
                component: EditNoteComponent},
            {path: 'list',
                component: ListNotesComponent},
            {path: 'edit/:id',
                component: EditNoteComponent},
            {path: 'view/:id',
                component: ViewNoteComponent},
        ]
    }
];



// WEBPACK FOOTER //
// ./src/app/notes/notes.routes.ts